import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})
export class ClassService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient,public router: Router)
   { }

  viewClass() {
    return this.http.get(this.baseurl +'/api/Classes/GetClasses')
  }

  getClass(id) {
    return this.http.get(this.baseurl + `/api/Classes/GetClass?id=${id}`)
  }

  addClass(classForm) {
    console.log(classForm);
    return this.http.post(this.baseurl+'/api/Classes', classForm)
  }

  editClass(id, classForm) {
    console.log(classForm);
    return this.http.put(this.baseurl+`/api/Classes/${id}`, classForm)
  }

  deleteClass(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Classes/${id}`)
  }
}
